export default "__VITE_ASSET__D251uq$p__"